
import { IType } from "api/types/_media";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { components } from "react-select";

interface Option {
  label: string;
  value: string;
}

interface DropdownOptionMultiProps {
  name?: string,
  dataList?: IType[],
  initialValue?: Option[] | Option | undefined;
  onChangeSelect?: (params: Option) => void;
  placeholder?: string,
  isHasOptionAll?: boolean,
  optionAll?: any
  isMulti?: boolean
}

const DropdownOptionMulti = ({
  name = '',
  initialValue = [],
  dataList = [],
  isHasOptionAll = false,
  optionAll,
  isMulti = true,
  placeholder = 'Select...',
  onChangeSelect,
}: DropdownOptionMultiProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const result: any = isHasOptionAll ? [optionAll].concat(dataList) : dataList;
    setOptions((_prev: any) => result);
  }, [JSON.stringify(dataList), JSON.stringify(optionAll), i18n?.language]);

  const MenuList = (props: any) => {
    let childComponent = props?.children;
    if (props?.children?.length > 0) {
      const allOption = props?.children?.filter(
        (item: any) => item?.props?.value === "all"
      );


      let fixedIndex = -1;
      if (allOption) {
        fixedIndex = props?.children.indexOf(allOption?.[0]);
      }
      const fixedElement = props?.children?.[fixedIndex];

      const childComponentFormat = (
        (fixedIndex != -1 ? props?.children.slice(1) : props?.children) || []
      )?.sort((a: any, b: any) => {
        let pointA = a.props.isSelected === true ? 1 : 0;
        let pointB = b.props.isSelected === true ? 1 : 0;
        return pointB - pointA;
      });

      if (fixedElement) {
        childComponent = [fixedElement, ...childComponentFormat];
      } else {
        childComponent = childComponentFormat;
      }
    }

    return (
      <components.MenuList {...props}>{childComponent}</components.MenuList>
    );
  };

  let isAllSelected = false;

  const OptionFormat = (props: any) => {
    if (props?.isSelected && props?.value === "all") {
      isAllSelected = true
    }

    return (
      <components.Option {...props} style={{ zIndex: 999 }}>
        <div className="d-flex align-items-center gap-2">
          {((props?.isSelected) || isAllSelected) ? (
            <i className="ri-check-line align-middle fs-14" />
          ) : (
            ""
          )}
          {props.data?.label}
        </div>
      </components.Option>
    );
  };


  useEffect(() => {
    if(isMulti && (initialValue as any)?.length > 0) {
      setOnChangeOption(initialValue)
    } else {
      if (((initialValue as any)?.value === optionAll?.value || !(initialValue as any)?.value) && isHasOptionAll) {
        setOnChangeOption(optionAll)
      }
    }
  }, [i18n.language, isHasOptionAll, JSON.stringify(initialValue)]);


  return (
    <React.Fragment>
      <Select
        key={i18n.language}
        cacheOptions
        options={options}
        isMulti={isMulti}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        name={name}
        value={initialValue}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={placeholder}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        formatOptionLabel={(option: any) => (<div className="d-flex">{option?.label}</div>)}
        className="search-filter-keyword dropdown-status-rounded"
        classNamePrefix="name-prefix"
        components={{
          Option: OptionFormat,
          MenuList: MenuList,
        }}
        styles={{
          option: (styles: any) => {
            let styleNew = {
              ...styles,
              backgroundColor: "white",
              zIndex: 99,
              color: "black",
            }

            return styleNew;
          },
          control: (styles: any, { isFocused }: any) => {
            return {
              ...styles,
              borderColor: "#e9ebec",
              borderRadius: "0.6rem",
              color: "white",
              "&:hover": { borderColor: "#009ef7" },
            };
          },
          multiValue: (styles: any) => {
            return {
              ...styles,
              backgroundColor: "#009ef7",
              zIndex: 3,
              marginTop: '5px'
            };
          },
          multiValueLabel: (styles: any) => ({
            ...styles,
            color: "white !important",
          }),
          menuPortal: (base: any) => ({
            ...base,
            zIndex: 1051,
          }),
        }}
      />
    </React.Fragment>
  );
};

export default DropdownOptionMulti;
